import IntegrationCollage from './integration-collage';

export default IntegrationCollage;
